<template>
  <div>
    <tabbar3Dian7
      v-if="config.ui_version == 3.7"
      :active="active"
    ></tabbar3Dian7>
    <tabbar3Dian8
      v-else-if="['3.8','3.8_2'].includes(config.ui_version)"
      :active="active"
    ></tabbar3Dian8>
    <tabbar v-else :active="active"></tabbar>
  </div>
</template>

<script>
import tabbar from './tabbar.vue';
import tabbar3Dian7 from './tabbar3.7.vue';
import tabbar3Dian8 from './tabbar3.8.vue';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['config'])
  },
  components: {
    tabbar,
    tabbar3Dian7,
    tabbar3Dian8
  },
  name: 'Icon',
  props: {
    name: String,
    active: {
      type: [String],
      required: 'home'
    }
  },
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>

<style scoped>
.pendant-AGM4D,
.pendant-left-keCbM {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.pendant-center-bQBE8 {
  height: 100%;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}

.pendant-right-Pu6sD {
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.zw6KEcLcR0TZl9aKmnoW {
  background: var(--theme-btm-bg-color);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(transparent),
    to(rgba(84, 84, 84, 0))
  );
  background-image: linear-gradient(180deg, transparent, rgba(84, 84, 84, 0));
  -webkit-box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  height: 1.24rem;
}
.anticon {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  display: inline-block;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
}
.zw6KEcLcR0TZl9aKmnoW .van-tabbar-item__text {
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  height: 0.54rem;
  line-height: 1.3;
  max-width: 1.6rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: pre-wrap;
}

.zw6KEcLcR0TZl9aKmnoW .van-tabbar-item {
  background: transparent;
  -ms-flex-pack: end;
  color: var(--theme-btm-def-color);
  font-size: 0.24rem;
  justify-content: center;
  padding-top: 0;
  align-items: center;
  /* justify-content: flex-end; */
  position: relative;
}
.zw6KEcLcR0TZl9aKmnoW .van-tabbar-item--active {
  background: transparent;
  color: var(--theme-filter-active-color);
}
</style>
